import { RemoteVoiceCommandPayload } from '@/survey-graphql';

import { VoiceCommandEvent } from './shared-survey-project-response-mode.types';

const BE_TYPE_TO_FE_TYPE: Record<string, VoiceCommandEvent['type']> = {
  NextQuestion: 'next_question',
  SubmitAnswer: 'submit_answer',
};

export function resolveRemoteVoiceCommand(
  payload: RemoteVoiceCommandPayload | null | undefined,
  isBlocked: boolean
): VoiceCommandEvent | null {
  if (isBlocked || !payload) return null;

  const feType = BE_TYPE_TO_FE_TYPE[payload.type];
  if (!feType) return null;

  return {
    type: feType,
    transcript: payload.transcript,
    triggerWord: payload.triggerWord ?? null,
    confidence: payload.confidence,
    timestamp: payload.timestamp,
  };
}

interface RemoteVoiceAction {
  transcript: string;
  isFinal: boolean;
  command: VoiceCommandEvent | null;
}

export function resolveRemoteVoiceAction(
  payload: RemoteVoiceCommandPayload | null | undefined,
  isBlocked: boolean
): RemoteVoiceAction | null {
  if (!payload || isBlocked) return null;

  return {
    transcript: payload.transcript,
    isFinal: payload.isFinal ?? true,
    command: resolveRemoteVoiceCommand(payload, false),
  };
}
